import { reactive } from 'vue';
import { useSnackBar } from '@/composition/snackBar';
export const useRequestWithSnackBar = (api) => {
    const { open } = useSnackBar();
    return async (param) => {
        return api(param).then(result => {
            if (result > 0) {
                open({ text: 'Saved successfully.', color: 'success' });
            }
            else {
                open({ text: 'An error occurred during processing.', color: 'error' });
            }
            return result;
        });
    };
};
export const useRequestApi = (fetchApi, defaultItem) => {
    const state = reactive({
        loading: false,
        data: defaultItem
    });
    function request(params) {
        if (state.loading) {
            return Promise.resolve(state.data);
        }
        state.loading = true;
        return fetchApi(params).then(res => {
            state.data = res;
            return res;
        }).catch((e) => {
            throw e;
        }).finally(() => {
            state.loading = false;
        });
    }
    return {
        state,
        request
    };
};
export const useFetchItems = (fetchApi, defaultItem = []) => {
    const { state, request } = useRequestApi(fetchApi, defaultItem);
    return {
        state,
        request
    };
};
export const useFetchPage = (fetchApi, option = { size: 15 }) => {
    let prevParams;
    const { state, request: search } = useRequestApi(fetchApi, {
        count: 0,
        from: 0,
        hasNext: false,
        hasPrevious: false,
        pages: 0,
        index: 0,
        items: [],
        size: 0
    });
    const request = (params) => {
        // default size
        prevParams = JSON.parse(JSON.stringify({ size: option.size, ...params }));
        state.data.items = [];
        return search(prevParams);
    };
    const reload = () => request(prevParams);
    const changePage = (page = 1) => {
        return request({ ...prevParams, page });
    };
    const changePageSize = (size) => {
        return request({ page: 1, ...prevParams, size });
    };
    return {
        state,
        request,
        reload,
        changePage,
        changePageSize
    };
};
